import React, { useState } from 'react';
import InputForm from '../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, TextField, Typography } from '@mui/material';
import { Input, Spin, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp, TextFields } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import CustuomTreeSelect from '../../../CustuomTreeSelect';
import RadioBox from '../../../Radiox';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import { Crypter } from '../../../../Functions/Security/Crypter';
import DataType from '../../../../Types/DataTablePiclist';
import Datas from '../../../../Data/Data.json'
import SearchModal from '../../../SearchModal';
import SearchInput from '../../../SearchInput';


let searchUser:Params={CodeAgence:'',Table: "UTILIS",Colonne1:"CODUTI",Colonne2:"NOMUTI",Colagence:'001',Choix:22} 


let searchTypAdr:Params={CodeAgence:'',Table: "UTILIS",Colonne1:"CODUTI",Colonne2:"NOMUTI",Colagence:'001',Choix:22} 



//Initialisation des parametres de recherche
let searchTitre :Params={CodeAgence:'TITRES',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'RUBRIQ',Choix:22}
let searchSituationFamiliale :Params={CodeAgence:"SITFAM",Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:"RUBRIQ",Choix:22}
let searchProspect :Params={CodeAgence:'DEMARC',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'RUBRIQ',Choix:22}
let searchClassRisque:Params={CodeAgence:'CLARIS',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'RUBRIQ',Choix:22}
let searchPays :Params={CodeAgence:'CDPAYS',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'RUBRIQ',Choix:22}
let searchActivite :Params={CodeAgence:'TABNAE',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'RUBRIQ',Choix:22}
let searchUniteInstitutionnel :Params={CodeAgence:'TABNUI',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'RUBRIQ',Choix:22} 
let searchRegimeMatrimonial :Params={CodeAgence:"REGMAT",Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:"RUBRIQ",Choix:22}
//
let searchNiveauInstruction :Params={CodeAgence:'',Table: "INSTRU",Colonne1:"CODINS",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchEthnie :Params={CodeAgence:'',Table: "ETHNIE",Colonne1:"CODETH",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchCateGo :Params={CodeAgence:'',Table: "CATEGO",Colonne1:"CATEGO",Colonne2:"LIBELLFR",Colagence:'101',Choix:22} 
let searchZoneGeo:Params={CodeAgence:'',Table: "RESIDE",Colonne1:"CDRESI",Colonne2:"LIBELLFR",Colagence:'101',Choix:22}
let searchCpt:Params={CodeAgence:'',Table: "AGENCE",Colonne1:"plc2",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGroup:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGes:Params={CodeAgence:'',Table: "GESTIONNAIRE",Colonne1:"CODGES",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchService:Params={CodeAgence:'',Table: "SERVICE",Colonne1:"CODSERV",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchIndice:Params={CodeAgence:'',Table: "CLIENT",Colonne1:"NUMCLI",Colonne2:"NOMCLI",Colagence:'101',Choix:22}
let searchCompte:Params={CodeAgence:'',Table: "COMPTES",Colonne1:"NUMCPT",Colonne2:"NOMCPT",Colagence:'101',Choix:22}
let searchStatus:Params={CodeAgence:'',Table: "Status",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchGroupUtilis:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchPlanCpte:Params={CodeAgence:'',Table: "V_COMPTE_CLIENTELE_PLANCP",Colonne1:"IDPLAN",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchPeriod:Params={CodeAgence:'',Table: "v_period_lib",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchTypeAmort:Params={CodeAgence:'',Table: "v_typeAmortissement_lib",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchTypeCalcul:Params={CodeAgence:'',Table: "v_typeCalcul_lib",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchTypePret:Params={CodeAgence:'',Table: "TYPEPRET",Colonne1:"TYPEPRET",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchSimul : Params={CodeAgence:'',Table: "SIMULPRET",Colonne1:"NUMSIMUL",Colonne2:"NOMCLI",Colagence:'101',Choix:22}


function Tab1(props:{form?: any, disabled?: boolean}){
  // USER SESSION
  const auth = useAuthUser()
  const user : Utilisateur = JSON.parse(JSON.stringify(auth()))


  // USER TOKEN
  const authHeader = useAuthHeader()

  const [Data,SetData]=React.useState<DataType[]>([]);

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
 
  const onSelectChange = (newSelectedRowKeys:any) => {
    //console.log('selectedRowKeys changed: ', rowSelection);
    setSelectedRowKeys(newSelectedRowKeys);
    const d = []
    for (let j = 0; j < newSelectedRowKeys.length; j++) {
      const element = newSelectedRowKeys[j];
      //console.log(Data[element as number])
      d.push((Data[element]).Code)
    }
    //console.log(d)
    localStorage.setItem(Datas.LocalVariable.groupPlanCp, Crypter.encrypt(JSON.stringify(d)))
  };
  const [loading, setLoading] =React.useState(false);
    

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  function loadGroup(){
    try{
      let groupPlanCp = JSON.parse(Crypter.decrypt(localStorage.getItem(Datas.LocalVariable.groupPlanCp)+'')+"")
      //console.log(groupPlanCp)
      const d : any = []
    for (let i = 0; i < Data.length; i++) {
      for (let j = 0; j < groupPlanCp.length; j++) {
        //console.log(groupPlanCp[j])
        if (Data[i].Code == groupPlanCp[j].IDPLAN ) {
          d.push(Data[i].key)
          //break;
        }
      }
    }
    setSelectedRowKeys(d)
    console.log(d)
    }catch(error){
      console.log(error)
    }
  }
  setTimeout(() => {
    if (selectedRowKeys.length == 0) {
      loadGroup()
    }
    try{
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setSelectedRowKeys([])
        //localStorage.clear()
      }
    }
    catch(error){
      console.log(error)  
    }
  }, 1);

  return(
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className = 'border' width={"85%"} position={"absolute"}>
         
          <Box display={"flex"} fontStyle="inherit" className = 'border-left'>
            
            <Box fontStyle="inherit" className = 'border-left'>
              
                {/* <SearInputM  width={4} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
                <SearchInput dissabledCode={props.disabled} notRequired enable width={7}  form = {props.form}  Titre='Recherche Simulation De Crédit'  label='Code Simul' name='NUMSIMUL' Parametre={searchSimul}/>
                <SearchInput width={7} dissabledCode={!props.disabled} dissabledLib={!props.disabled}  form = {props.form}  Titre='Recherche Client'  label='Indice Client' name='NUMCLI' Parametre={searchIndice}/>
                <SearchModal  width={7}  form = {props.form}  Titre='Recherche Périodicité'  label='Périodicité' name='PERIODIC' Parametre={searchPeriod}/>
                <InputForm width={11} label='Montant Epargne' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='MONTEPARG'  type='number' error='mobile' />
                <InputForm width={11} label='Taux Intéret Annuel' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='TAUXINT'  type='money' error='mobile' />
            </Box>
            <Box fontStyle="inherit" className = 'border-left'>
                <InputForm width={11} label='Nombre Pde Differé' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='NBPERDIF'  type='number' error='mobile' />
                <SearchModal width={7}  form = {props.form}  Titre='Recherche Type Pret'  label='Type Pret' name='TYPEPRET' Parametre={searchTypePret}/>
                <SearchModal width={7}  form = {props.form}  Titre='Recherche Type Amortissement'  label='Type Amort' name='TYPAMORT' Parametre={searchTypeAmort}/>
                <InputForm width={11} label='Taux Epargne' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='TAUXEPAR'  type='money' error='mobile' />
                <InputForm width={11} label='Nombre Echéance' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='NBRECHE'  type='number' error='mobile' />
            </Box>
            <Box fontStyle="inherit" className = 'border-left'>
                <InputForm width={11} label='Montant Pret' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='MONTAN'  type='number' error='mobile' />
                <SearchModal width={7}  form = {props.form}  Titre='Recherche Type Calcul'  label='Type Calcul' name='TYPCALC' Parametre={searchTypeCalcul}/>
                <InputForm width={11} label='Taux Taxe' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='TAUXTAX'  type='money' error='mobile' />
                <InputForm width={11} label='Date 1ère Echéance' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='DAT1ECHE'  type='date' error='mobile' />
            </Box>
          </Box> 
        </Box>
      </div>
    </div>
  )
}

export default Tab1;  
